export const expenseFormComponent = {
	addButton: "Lançar Despesa",
	concludeButton: "Concluir Lançamento",
	editButton: "Editar Despesa",
};
